export default __webpack_public_path__ + "static/media/nanonews.cd4dc5ce.svg";